import CustomPreviewWhatsApp from "../../components/utils/CustomPreviewWhatsApp"
import { NotificationManager } from "../../components/common/react-notifications"
import _moment from "../../libs/moment"
import _axios from "../../libs/axios"
import { objToQueryString } from "../../helpers/Utils"
import { replaceWords } from "../../helpers/Utils"

export default (context) => {
    const M = "admNotification."
    const onSuccess = (r) => {
      const form = context.state.form
      form.msgConfirmFailure = null
      form.msgConfirmSuccess = r.msg
      if (context.state.form.btnValidate !== -2) form.btnValidate = r.status
      context.setState({form: form})
      context.props.setLoader(false)
      if (context.state.form.btnValidate === -2) context.toggle()
      else {
        if (!context.state.idItemSelected) {
          context.setState({showFormCustom: false, btnCancel: "main.close"}, () => {
            context.getDataById(r.data)
          })
        }
      }
    }
    const onFailure = (r) => {
      const form = context.state.form
      form.msgConfirmSuccess = null
      form.msgConfirmFailure = r.msg
      context.setState({form: form})
      context.props.setLoader(false)
    }
    const changeTemplate = (ctx) => {
      const params = {
        objectType: ctx.state.page,
        objectId: ctx.state.objectId
      }
      const query = objToQueryString(params)
      context.props.setLoader(true)
      _axios
        .get(`admLocalization/get/${ctx.state.doWATemplate}?${query}`)
        .then(r => {
          context.props.setLoader(false)
          if (r.status >= 0) {
            const fields = []
            r.data.tagsContent.forEach((t, i) => {
              if (context.state.idItemSelected && ctx.state.placeholders?.length > 0 && !ctx.state.selectedTemplate) {
                ctx.setState({[t.id]: ctx.state.placeholders[i]?.name ?? t.defValue })
              }
              else ctx.setState({[t.id]: t.defValue ?? ""})
              fields.push(
                {
                  col: 6,
                  name: t.id,
                  value: "",
                  type: t.hidden ? "hidden" : "text",
                  label: (L) => {
                    let label = t.id.split(".")
                    label = label.pop()
                    return L[`${M}${label}`] || L[`main.${label}`] || t.id
                  },
                  opts: {
                    style: 'float-label',
                  },
                  disabled: t.readonly
                }
              )
            })
            
            ctx.setState({ selectedTemplate: r.data })
            const formFields = context.state.formFields
            const fieldIndex = formFields.findIndex(f => f.name === "placeholders")
            formFields[fieldIndex].childs = fields
            context.setState({formFields: formFields})
          } else NotificationManager.error(r.msg, "Opps", 5000, null, null, 'outline')
        }).catch(e => context.props.setLoader(false))
    }

    return {
      config: {
        pageSize: 10,
      },
  
      actions: {
        create: {
          reloadGrid: true
        },
        edit: true,
        delete: true,
        print: true,
        export: true,
        search: true
      },
  
      filter: {
        fields: [
          {
            type: "daterange",
            range: {
              label: "Enviado durante"
            }
          },
          {
            col: 3,
            name: "status",
            value: 0,
            type: "select",
            label: "main.status",
            opts: {
              style: 'float-label',
              items: [
                {
                  value: -1,
                  label: "main.all"
                },
                {
                  value: 0,
                  label: `admFlow.draft`
                },
                {
                  value: 1,
                  label:  `admFlow.noSent`
                },
                {
                  value: 2,
                  label: `admFlow.sending`
                },
                {
                  value: 3,
                  label: `admFlow.sent`
                },
                {
                  value: 5,
                  label: `admFlow.paused`
                },
                {
                  value: -1,
                  label: `admFlow.seeErrors`
                }
              ]
            }
          }
        ],
        buttons: [
          {
            label: 'main.applyFilter',
            onClick: (ctx) => { ctx.btnAction('filter') }
          }
        ]
      },

      form: {
        handleSaveChanges : () => {
          const form = context.state.form
          form.btnValidate = -2
          context.setState({form: form}, () => {
            context.state.idItemSelected ? context.edit() : context.create()
          })
        },
        remapOne: (r) => {
          if (r.status >= 0) {
            const { doWATemplate, doWATemplateName, objectId, recurrence, sendOn } = r.data
            const { L } = context.state
            const d = _moment(sendOn)
            let recurrenceName = ""
            if (recurrence) {
              const value = recurrence.split(" ")
              const day = value[2]
              const month = value[3]
              if (day === "*" && month === "*") recurrenceName = replaceWords(L[`${M}everyWeek`], {"{0}": d.format("dddd"), "{1}": d.format("hha")})
              else if (month === "*") recurrenceName = replaceWords(L[`${M}everyMonth`], {"{0}": d.format("DD"), "{1}": d.format("hha")})
              else recurrenceName = replaceWords(L[`${M}everyYear`], {"{0}": d.format("DD-MMM"), "{1}": d.format("hha")})
            }
            r.data = {
              ...r.data,
              doWATemplate: doWATemplate ? { value: doWATemplate, label: doWATemplateName } : doWATemplate,
              objectId: objectId ? { value: objectId, label: objectId } : objectId,
              hasRecurrence: !!recurrence,
              recurrence: recurrence ? { value: recurrence, label: recurrenceName } : recurrence
            }
          }
          return r
        },
        setValuesBeforePost: (v) => {
          if (v.sectionIds) v.sectionIds = v.sectionIds.map(e => e = { ID: e.value, name: e.label, selected: true })
          if (v.userIds) v.userIds = v.userIds.map(e => e = { ID: e.value, name: e.label, selected: true })
          if (v.principalUserIds) v.principalUserIds = v.principalUserIds.map(e => e = { ID: e.value, name: e.label, selected: true })
          const tagsContent = v.selectedTemplate?.tagsContent
          let placeholders = []
          if (v.selectedTemplate?.tagsContent) {
            tagsContent.forEach(t => {
              placeholders.push({ID: t.id, name: v[t.id] || ""})
            })
            v.placeholders = placeholders
          }
          delete v.alert1
          delete v.alert2
          delete v.msgConfirmFailure
          delete v.msgConfirmSuccess
          delete v.btnValidate
          delete v.selectedTemplate
          return v
        },
        onCreateSuccess: onSuccess,
        onCreateFailure: onFailure,
        onEditSuccess: onSuccess,
        onEditFailure: onFailure,
        onGetDataById: () => {
          context.setState({showFormCustom: true})
        },
        fields: [
          {
            col: 12,
            name: "name",
            value: "",
            type: "text",
            label: `${M}internalName`,
            rules: "required|max:50",
            opts: {
              style: 'float-label',
            }
          },
          {
            col: 12,
            name: "label1",
            value: L => `<h5>${L[`${M}deliveryModes`]}</h5>`,
            type: "label"
          },
          {
            col: 4,
            name: "doWA",
            value: false,
            type: "switch",
            label: "main.whatsApp",
            onChange: (ctx) => ctx.setState({selectedTemplate: null}, () => {
              context.setState({modalPreview: false})
            })
          },
          {
            col: 8,
            name: "doWATemplate",
            value: "",
            type: "select",
            label: `${M}whatsAppTemplate`,
            rules: "required",
            opts: {
              style: 'float-label',
              path: "/admLocalization/get?type=w&pick=true",
              addon: {
                append: {
                  buttons: [
                    {
                      disabled: ctxField => !ctxField.state.doWATemplate,
                      name: "main.preview",
                      onClick: () => context.togglePreview()
                    }
                  ]
                }
              }
            },
            onChange: (ctx) => {
              if (!ctx.state.doWATemplate) {
                ctx.setState({selectedTemplate: null})
                return
              }
              changeTemplate(ctx)
            },
            renderIf: ctx => ctx.state.doWA
          },
          {
            col: 12,
            name: "placeholders",
            value: [],
            type: "fieldset",
            renderIf: ctx => ctx.state.doWA
          },
          {
            col: 4,
            name: "doMail",
            value: false,
            type: "switch",
            label: `${M}sendEmail`
          },
          {
            col: 4,
            name: "doPush",
            value: false,
            type: "switch",
            label: `${M}sendPUSH`
          },
          {
            col: 12,
            name: "alert2",
            value: `${M}infoPush`,
            type: "alert",
            opts: {
              color: "info"
            },
            renderIf: ctx => ctx.state.doPush
          },
          {
            col: 12,
            name: "content",
            value: "",
            type: "text",
            label: "main.title",
            rules: "required",
            opts: {
              style: 'float-label',
            },
            renderIf: (ctx) => ctx.state.doMail || ctx.state.doPush
          },
          {
            col: 12,
            name: "body",
            value: "",
            type: "editor",
            label: "main.content",
            renderIf: (ctx) => ctx.state.doMail
          },
          {
            col: 12,
            name: "art",
            value: "",
            type: "dropzone",
            label: "",
            isDoc: false,
            rules: 'ext:jpeg,jpg,png',
            placeholder: "main.selectFile",
            opts: {
              path: ()=> "/admNotification/file",
              accept: '.jpeg,.jpg,.png',
              output: true
            }
          },
          {
            col: 6,
            name: "sendTo",
            value: 0,
            type: "select",
            label: `${M}sendTo`,
            opts: {
              style: 'float-label',
              items: [
                { value: 0, label: `${M}headlinesGuardians` },
                { value: 2, label: `${M}childrenDependents` },
                { value: 4, label: `${M}teachers` }
              ]
            }
          },
          {
            col: 6,
            name: "filterBy",
            value: "sections",
            type: "select",
            label: `${M}selectionCriteria`,
            opts: {
              style: 'float-label',
              items: [
                { value: "sections", label: `${M}filterBySections` },
                { value: "dependants", label: `${M}filterBySpecificChildrenDependents` },
                { value: "principals", label: `${M}filterBySpecificHeadlinesGuardians` }
              ]
            }
          },
          {
            col: 12,
            name: "sectionIds",
            value: "",
            type: "select",
            label: `${M}selectFromSections`,
            opts: {
              style: 'float-label',
              path: "/admSection/get",
              isMulti: true,
              setOutput: v => v
            },
            renderIf: ctx => ctx.state.filterBy === "sections"
          },
          {
            col: 12,
            name: "userIds",
            value: "",
            type: "select",
            label: `${M}relatedToFollowingChildrenDependents`,
            opts: {
              style: 'float-label',
              path: "/admUser/get?pick=true&type=3",
              isMulti: true,
              setOutput: v => v
            },
            renderIf: ctx => ctx.state.filterBy === "dependants"
          },
          {
            col: 12,
            name: "principalUserIds",
            value: "",
            type: "select",
            label: `${M}relatedToFollowingHeadlinesGuardians`,
            opts: {
              style: 'float-label',
              path: "/admUser/get?pick=true&type=1",
              isMulti: true,
              setOutput: v => v
            },
            renderIf: ctx => ctx.state.filterBy === "principals"
          },
          {
            col: 6,
            name: "page",
            value: "general",
            type: "select",
            label: `${M}notificationType`,
            opts: {
              style: 'float-label',
              items: [
                { value: "general", label: `${M}general` },
                { value: "publication", label: `${M}publication` },
                { value: "calendar", label: `${M}eventCalendar` },
                { value: "payment", label: `${M}payments` },
                { value: "attendance", label: `${M}attendance` }
              ]
            },
            onChange: ctx => {
              if (!ctx.state.selectedTemplate) return
              changeTemplate(ctx)
            }
          },
          {
            col: 6,
            name: "objectId",
            value: "",
            type: "select",
            label: `${M}associateNotificationWith`,
            parent: "page",
            opts: {
              style: 'float-label',
              path: ctx => `admNotification/objects?parentId=${ctx.state.page}`
            },
            onChange: ctx => {
              if (!ctx.state.selectedTemplate) return
              changeTemplate(ctx)
            }
          },
          {
            col: 6,
            name: "sendOn",
            value: "",
            type: "datetime",
            label: `${M}sendDate`,
            rules: "required",
            opts: {
              style: 'float-label',
              selectsEnd: true,
              minDate: _moment(),
              minTime: ctx => ctx.state.sendOn ? _moment(ctx.state.sendOn).format('YYYY-MM-DD') === _moment().format('YYYY-MM-DD') ? _moment() : _moment().set({hour:0,minute:0}) : _moment(),
              maxTime: _moment().set({hour:23,minute:59,second:0,millisecond:0}),
            }
          },
          {
            col: 2,
            name: "hasRecurrence",
            value: false,
            type: "switch",
            label: `${M}recurrence`,
            renderIf: ctx => ctx.state.sendOn && ctx.state.recurrenceId === 0
          },
          {
            col: 2,
            name: "recurrenceId",
            value: 0,
            type: "hidden"
          },
          {
            col: 4,
            name: "recurrence",
            value: null,
            type: "select",
            parent: "sendOn",
            rules: "required",
            opts: {
              style: 'float-label',
              items: [],
              onMenuOpen: (ctxForm, ctx, L) => {
                const d = _moment(ctxForm.state.sendOn)
                const items =  [
                  { value: `0 ${d.format("H")} * * ${d.day()}`, label: replaceWords(L[`${M}everyWeek`], {"{0}": d.format("dddd"), "{1}": d.format("hha")})},
                  { value: `0 ${d.format("H")} ${d.format("D")} * *`, label: replaceWords(L[`${M}everyMonth`], {"{0}": d.format("DD"), "{1}": d.format("hha")})},
                  { value: `0 ${d.format("H")} ${d.format("D")} ${d.format("M")} *`, label: replaceWords(L[`${M}everyYear`], {"{0}": d.format("DD-MMM"), "{1}": d.format("hha")})}
                ]
                ctx.setState({items: items})
              }
            },
            renderIf: ctx => ctx.state.sendOn && ctx.state.hasRecurrence && ctx.state.recurrenceId === 0
          },
          {
            col: 6,
            name: "btnValidate",
            value: -1,
            type: "button",
            label: `${M}validateSending`,
            onClick: () => {
              context.state.idItemSelected ? context.edit() : context.create()
            },
            renderIf: ctx => !ctx.state.confirm
          },
          {
            col: 6,
            name: "confirm",
            value: false,
            type: "switch",
            label: `${M}startSending`,
            renderIf: ctx => ctx.state.btnValidate >= 0 || context.state.idItemSelected
          },
          {
            col: 12,
            name: "msgConfirmSuccess",
            value: "",
            type: "alert",
            opts: {
              color: "success"
            },
            renderIf: () => context.state.form?.msgConfirmSuccess
          },
          {
            col: 12,
            name: "msgConfirmFailure",
            value: "",
            type: "alert",
            opts: {
              color: "danger"
            },
            renderIf: () => context.state.form?.msgConfirmFailure
          },
        ],
      },
  
      columns: [
        {
          Header: "main.name",
          accessor: "name",
          width: 200
        },
        {
          Header: "main.status",
          accessor: "status",
          type: 'chip',
          chips: {
            0: {text: 'Draft', color:'lightgreen'},
            1: {text: 'Ready', color:'lightgreen'},
            2: {text: 'Sending', color:'lightgreen'},
            3: {text: 'Sent', color:'green'},
            4: {text: 'Cancelled', color:'red'},
            5: {text: 'Sending errors', color:'red'}
          }
        },
        {
          Header: `${M}sendDate`,
          accessor: "sendOn",
          isDate:true
        },
        {
          Header: 'admFlow.countTarget',
          accessor: "total"
        },
        {
          Header: `${M}sent`,
          accessor: "sent",
          width: 80
        },
        {
          accessor: "sentProgress",
          type:'progress'
        },
        {
          Header: 'admFlow.countSeen',
          accessor: "read",
          width: 80
        },
        {
          accessor: "readProgress",
          type:'progress'
        },
        {
          Header: `${M}failed`,
          accessor: "failed"
        }
      ],

      preview: {
        template: CustomPreviewWhatsApp,
        previewOf: {
          form: {
            name: `main.whatsappMessagePreview`,
            handleData: (data) => {
              if (!data) return
              let msgs = []
              let content = data?.selectedTemplate?.content
              let buttons = []
              const tagsContent = data?.selectedTemplate?.tagsContent
              if (tagsContent) {
                /*
                tagsContent.forEach(t => {
                  if (data[t.id]) {
                    content = content.replaceAll(`{{${t.id}}}`, data[t.id])
                  }
                })
                */
                tagsContent.forEach((t, index) => {
                  if (data[t.id]) {
                    content = content.replaceAll(`{{${index+1}}}`, data[t.id])
                  }
                  if (t.id.includes("button")) {
                    buttons.push(data[t.id])
                  }
                })
              }
              const msg = {
                type: "received",
                content: content,
                buttons: buttons
              }
              msgs.push(msg)
              return msgs
            }
          }
        },
        renderIf: () => context.state.form.selectedTemplate
      }
    }
  }